import { LogicalPosition } from "@tauri-apps/api/window";
import { WebviewWindow } from "@tauri-apps/api/webviewWindow";
import { useOnMount } from "./useOnMount.js";
import { useUiIsLocked } from "./useUiIsLocked";
/**
 * hook for tauri to center the mouse in the middle of element
 * @param ref ref to a Pixi Container
 * @param widthOverride
 * @param heightOverride
 */
export const useCenterCursor = (ref, widthOverride, heightOverride) => {
    const uiIsLocked = useUiIsLocked();
    useOnMount(() => {
        if (window.__TAURI__ && ref.current && !uiIsLocked) {
            const rect = ref.current.getBounds();
            const pos = ref.current.getGlobalPosition();
            const newCursorPos = {
                x: pos.x + (widthOverride ?? rect.width) / 2,
                y: pos.y + (heightOverride ?? rect.height) / 2,
            };
            void WebviewWindow.getCurrent().setCursorPosition(new LogicalPosition(newCursorPos.x - 1, newCursorPos.y - 1));
        }
    });
};
//# sourceMappingURL=useCenterCursor.js.map